import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * @deprecated Use `glxy-empty-state`: https://github.com/vendasta/galaxy/tree/master/libs/galaxy/empty-state
 */
@Component({
  selector: 'uikit-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  standalone: false,
})
export class EmptyStateComponent {
  // Can only provide one of iconName or svgIconName
  @Input() iconName?: string; // A material icon name
  @Input() svgIconName?: string; // A SVG icon name, prerequisite: MUST be registered by hosting app
  @Input() title?: string;
  @Input() ctaPrimaryText?: string;
  @Input() ctaSecondaryText?: string;

  @Output() ctaPrimaryEvent: EventEmitter<null> = new EventEmitter();
  @Output() ctaSecondaryEvent: EventEmitter<null> = new EventEmitter();

  public primaryAction(): void {
    this.ctaPrimaryEvent.emit(null);
  }

  public secondaryAction(): void {
    this.ctaSecondaryEvent.emit(null);
  }
}
